import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Editor } from '../../plugins/froala';
import { Labeled } from '../../components/Labeled';
import { TextField } from '../../components/TextField';
import { api } from '../../plugins/axios';
import { fetcher } from '../../plugins/react-query';
import {
  postAdminH1,
  postHasContent,
  postHasDate,
  postHasDescription,
  postHasPriority,
  postHasSubType,
  postHasThumbnail,
  postHasUrl,
  postPath,
  usePostType,
} from '../../post-config';
import { Post, PostSubType } from '../../types';
import { AdminH1 } from '../components/AdminH1';
import { ImageUplaod } from '../../components/ImageUpload';
import { Select } from '../../components/Select';
import { Toggle } from '../../components/Toggle';

export const PostEdit = () => {
  const { push } = useHistory();
  const postType = usePostType(true);
  const { id } = useParams<{ id: string }>();
  const { data: post, isSuccess } = useQuery<Post>(
    `/admin/posts/${id}`,
    fetcher,
  );
  const [title, setTitle] = useState('');
  const [subType, setSubType] = useState<string>();
  const [description, setDescription] = useState('');
  const [url, setUrl] = useState('');
  const [dateString, setDateString] = useState('');
  const [thumbnail, setThumbnail] = useState<File | null>(null);
  const [priority, setPriority] = useState(0);
  const [isMainPost, setIsMainPost] = useState(post ? post.isMainPost : false);

  const [content, setContent] = useState('');
  useEffect(() => {
    if (!post) return;
    setTitle(post.title);
    setSubType(post.subType);
    setDescription(post.description);
    setUrl(post.url);
    setDateString(post.dateString);
    setPriority(post.priority);
    setContent(post.content);
    setIsMainPost(post.isMainPost);
  }, [post, isSuccess]);

  async function save() {
    const patchData: any = {
      subType,
      title,
      description,
      url,
      priority,
      dateString,
      content,
      isMainPost,
    };
    if (thumbnail) {
      const formData = new FormData();
      formData.append('file', thumbnail);
      const { data: url } = await api.post('/s3/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      patchData.thumbnail = url;
    }
    await api
      .patch(`/admin/posts/update/${id}`, patchData)
      .then(() => {
        push(`/admin/${postPath(postType)}/${id}`);
      })
      .catch((e) => {
        alert(e.response.data.message);
      });
  }

  if (!post) return <></>;
  return (
    <>
      <AdminH1>{postAdminH1(postType)}</AdminH1>

      <Card>
        <div className="space-y-6 px-4 py-6 sm:px-6 md:px-8">
          {postHasSubType(postType) && (
            <Select
              label="Select"
              value={subType}
              onChange={(e) => setSubType(e.target.value)}
            >
              <option
                label={PostSubType.LEGAL_PRACTICE_DIVISION}
                value={PostSubType.LEGAL_PRACTICE_DIVISION}
              />
              <option
                label={PostSubType.PUBLIC_AND_PROFESSIONAL_INTEREST_DIVISION}
                value={PostSubType.PUBLIC_AND_PROFESSIONAL_INTEREST_DIVISION}
              />
            </Select>
          )}
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          {postHasDate(postType) && (
            <TextField
              label="Date"
              value={dateString}
              onChange={(e) => setDateString(e.target.value)}
            />
          )}
          {postHasPriority(postType) && (
            <TextField
              label="Priority"
              type="number"
              value={priority}
              onChange={(e) => setPriority(Number(e.target.value))}
            />
          )}
          {postHasDescription(postType) && (
            <TextField
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          )}
          {postHasUrl(postType) && (
            <TextField
              label="URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          )}
          {postHasThumbnail(postType) && (
            <ImageUplaod
              label="Thumbnail"
              file={thumbnail}
              onChange={(e) =>
                e.target.validity.valid &&
                e.target.files &&
                setThumbnail(e.target.files.item(0))
              }
            />
          )}
          {postHasContent(postType) && (
            <Labeled label="Content">
              <div style={{ width: '745px' }}>
                <Editor
                  model={content}
                  onModelChange={(model: any) => setContent(model)}
                />
              </div>
            </Labeled>
          )}

          <div className="flex space-x-2">
            <Toggle
              onChange={() => {
                setIsMainPost(!isMainPost);
                console.log('Toggled isMainPost:', !isMainPost); // 토글 이벤트 로그
              }}
              checked={isMainPost}
            />
            <p className="text-gray-400">대표 게시글 여부</p>
          </div>
        </div>

        <div className="flex justify-end space-x-4 px-4 py-4 sm:px-6 md:px-8">
          <Button
            text="Cancel"
            to={`/admin/${postPath(postType)}/${id}`}
            className="h-10 text-sm outlined-gray-600 hover:bg-gray-50"
          />
          <Button
            text="Save"
            className="h-10 text-sm filled-indigo-500 hover:bg-indigo-600"
            disabled={!title}
            onClick={save}
          />
        </div>
      </Card>
    </>
  );
};
